/**
 * JavaScript controller for shortcode: profession_cta_buttons
 */
Mmg.addShortcode('profession_cta_buttons', '.sc-profession-cta-buttons', (el, model, $, selector) => {

  const $sentinel = $(`${selector}__wrapper`);
  const $moveable = $sentinel.children();
  const $slot = $('.header__widget-slot-below');


  /**
   * Initialize the widget
   */
  (function init() {
    observeScroll();
  })();


  /**
   * Toggle CTA bar position based on scroll position
   */
  function observeScroll() {
    new IntersectionObserver(
      ([e]) => {
        const offscreen = (e.boundingClientRect.height + e.boundingClientRect.top) < 0;

        const $target = offscreen ? $slot : $sentinel;
        $moveable.appendTo($target);
      },
      { threshold: [0, 1] }
    ).observe($sentinel[0]);
  }
});
